<div class="org-chart-container" #containerRef>
  <div *ngIf="isLoading; else showChart" class="container__loading">
    <mat-spinner></mat-spinner>
  </div>
  <ng-template #showChart>
    <div shc-zoom-pan-container [minZoom]="0.3" #zoomPan>
      <div *ngIf="!teamsData.length && !isLoading; else hasData" class="container__no-data">
        Organization chart data not available.
      </div>
      <ng-template #hasData>
        <div
          #chartRef
          class="org-chart relative top-[30%] left-1/2"
          [style.transform]="'translateX(-50%) scale(' + scaleInit + ')'"
        >
          <ul>
            <li>
              <div class="node group-name !px-10 !py-5 !text-2xl">B3NetWorks</div>
              <ul class="!pt-14 before:!h-14">
                <li *ngFor="let team of teamsData" [ngClass]="{ 'after:!w-1/2 !mr-0': !team.membersDirectory?.length }">
                  <div class="node group-name">{{ team?.name }}</div>
                  <ul *ngIf="team.membersDirectory?.length">
                    <li
                      *ngFor="let member of team.membersDirectory"
                      [ngClass]="{ 'left-1/2 -translate-x-1/2': team.membersDirectory.length === 1 }"
                    >
                      <div class="node node-leak" (click)="openDialogInfoMember(member)">
                        <img *ngIf="member.photoUrl; else elseAvatar" [src]="member.photoUrl" alt="avatar" />
                        <ng-template #elseAvatar>
                          <div
                            class="w-[100px] h-[100px] rounded-md border border-[#80808045] bg-gray-100 mr-[10px] flex items-center justify-center"
                          >
                            <mat-icon class="s-80 text-gray-400 material-symbols-rounded fill">person</mat-icon>
                          </div>
                        </ng-template>
                        <div class="info">
                          <div class="name">{{ member.name }}</div>
                          <div class="ext">Ext {{ member.extensionKey ?? 'N/A' }}</div>
                          <div class="email">{{ member.email ?? 'N/A' }}</div>
                          <div
                            [ngClass]="
                              member.teamRole ? 'badges ' + member.teamRole.toLocaleLowerCase() : 'badges empty'
                            "
                          >
                            {{ member.teamRole ? member.teamRole : 'NA' }}
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
